import { render } from "./ToStartQCChartResults.vue?vue&type=template&id=3afa60c3"
import script from "./ToStartQCChartResults.vue?vue&type=script&lang=js"
export * from "./ToStartQCChartResults.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/QCCharts/ToStartQCChartResults.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3afa60c3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3afa60c3', __exports__)) {
    console.log('reload')
    api.reload('3afa60c3', __exports__)
  }
  
  module.hot.accept("./ToStartQCChartResults.vue?vue&type=template&id=3afa60c3", () => {
    console.log('re-render')
    api.rerender('3afa60c3', render)
  })

}


export default __exports__